/**
 * INVENTA API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TimespanComProvider { 
    startDate?: string;
    endDate?: string;
    data: TimespanComProvider.DataEnum;
}
export namespace TimespanComProvider {
    export const DataEnum = {
        GroundControl: 'GROUND_CONTROL',
        MetOcean: 'MET_OCEAN',
        Globalstar: 'GLOBALSTAR',
        Orbcomm: 'ORBCOMM',
        IridiumJapan: 'IRIDIUM_JAPAN'
    } as const;
    export type DataEnum = typeof DataEnum[keyof typeof DataEnum];
}


